

    var doc = JSON.parse("{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"FragmentDefinition\",\"name\":{\"kind\":\"Name\",\"value\":\"PermissionFields\"},\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"PermissionSet\"}},\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"video\"},\"arguments\":[],\"directives\":[]}]}}],\"loc\":{\"start\":0,\"end\":55}}");
    doc.__key = 0x11846faf6d5f;
    doc.loc.source = { body: "11846faf6d5f" };
  


      export default doc;
    
